export default "__VITE_ASSET__4c6051d1__"